import { useState } from 'react';

import { useGameContext } from '~/contextProviders/GameContextProvider';


export default function BattleBatchAttacks() {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="battle-rules-button__wrapper battle-batch-button__wrapper">
      <button className={`battle-rules-button ${expanded && 'battle-rules-button--expanded'}`} onClick={() => setExpanded(!expanded)} type="button">
        <img src="/img/up.icon.png" alt="Toggle" />
        <span className="battle-rules-button__label">Select multiple attacks</span>
      </button>
      <div className={`battle-rules__rules ${expanded && 'battle-rules__rules--expanded batch-rules__rules--expanded'}`}>
        <BatchLegend visible={expanded} />
      </div>
    </div>
  );
}

const batchAttackIDs = {
  loyalist: 'loyalist',
  random: 'random',
  opponent: 'opponent',
  counterCounter: 'counterCounter',
};

const BatchAttackRow = ({ id, label, type }: { id: string; label: string; type: string; }) => {
  const { batchAttack, setBatchAttack, totalBatchAttackSuccess, setTotalBatchAttackSuccess } = useGameContext();

  const handleBatchClick = (id: string) => {
    setTotalBatchAttackSuccess(false);
    setBatchAttack(id);
  };

  let status = '';
  if (batchAttack === id) {
    if (totalBatchAttackSuccess) {
      status = 'success';
    } else {
      status = 'loading';
    }
  }

  return (
    <tr data-id={id}>
      <td className="batch-button-column">{label}</td>
      <td>{type}</td>
      <td className="batch-status-column">
        {status === 'loading' ?
          'Submitting...' :
          <button
            className={'button batch--button'}
            onClick={() => handleBatchClick(id)}
          >{status === 'success' ? '✅ Submitted' : 'Submit'}</button>
        }
      </td>
    </tr>
  );
};

function BatchLegend({ visible }: { visible: boolean }) {
  return (
    <table className={`attack-legend ${visible && 'batch-legend--visible'}`}>

      <thead>
        <tr>
          <th>Attack</th>
          <th>Type</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <BatchAttackRow
          id={batchAttackIDs.loyalist}
          label="✚ HP Bonus"
          type="Defaults to your Syndicate — last attack if Spirit, different last attack if Renegade (random if first Round)"
        />
        <BatchAttackRow
          id={batchAttackIDs.random}
          label="🎲 Randomizer"
          type="Selects random attack"
        />
        <BatchAttackRow
          id={batchAttackIDs.opponent}
          label="🗡 Counter attack"
          type="Select attacks based on your opponent's Syndicate"
        />
        {/* <BatchAttackRow
          id={batchAttackIDs.counterCounter}
          label="🗡 Counter Counter attack"
          type="Select attacks based on your opponent's counter attack"
        /> */}
      </tbody>
    </table>
  );
}

